//#region src/compound_mod_group_slot_type.ts
let CompoundModGroupSlotType = /* @__PURE__ */ function(CompoundModGroupSlotType) {
	CompoundModGroupSlotType["Empty"] = "empty";
	CompoundModGroupSlotType["Placeholder"] = "placeholder";
	CompoundModGroupSlotType["Real"] = "real";
	return CompoundModGroupSlotType;
}({});
//#endregion
export { CompoundModGroupSlotType };

//# sourceMappingURL=compound_mod_group_slot_type.js.map